import { useIntl } from 'react-intl';

import { PlayerType } from '@/scenarios/legacy-player/components/feature-player/ui/player/container';

export const useSmokingWarningText = (contentType: PlayerType) => {
    const intl = useIntl();

    switch (contentType) {
        case 'film':
            return intl.formatMessage({
                id: 'components.PlayerSkin.6ad454c30bb441a018d8baf28f2a1676',

                defaultMessage: 'This movie contains smoking scenes. Smoking kills.',
                description: 'Предупреждение о курении в фильме',
            });
        case 'episode':
            return intl.formatMessage({
                id: 'components.PlayerSkin.75aeda4f65935fad87fd2792d561bd3a',

                defaultMessage: 'This TV series contains smoking scenes. Smoking kills.',
                description: 'Предупреждение о курении в сериале',
            });
        default:
            return '';
    }
};
